import Vue from 'vue'
import Vuex from 'vuex'
import { getUserInfo, logout } from '../pages/User/service/api';
import { getAllUnReadTotal } from '../pages/System/service/api';
import tempUserImg from '@/assets/images/avantor.jpeg';

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    menus: [{
      uri: '/',
      name: '首页'
    }, {
      uri: '/aboutus',
      name: '学会简介'
    },{
      uri: '/news',
      name: '新闻动态'
    }, {
      uri: '/member',
      name: '会员之家'
    }, {
      uri: '/activity',
      name: '学会活动'
    }, {
      uri: '/publish',
      name: '编辑出版'
    }, 
    // {
    //   uri: '/education',
    //   name: '园林教育'
    // }, 
    {
      uri: '/wiki',
      name: '科普教育'
    }, {
      uri: '/party',
      name: '党建引领'
    },{
      uri: '/policy',
      name: '政策法规'
    }],
    user: null,
    activeMenuUri: '/',
    unReadCount: 0
  },
  mutations: {
    SETACTIVEMENU(state, payload) {
      state.activeMenuUri = payload.activeMenuUri;
    },
    SETUSERINFO(state, payload) {
      if (state.user && !state.user.memOrgVo) {
        state.user.memOrgVo = {};
      }
      if (state.user && !state.user.memPersonalVo) {
        state.user.memPersonalVo = {};
      }
      state.user = payload;
      if (!state.user) return;
      const typeMap = {
        org: '团体会员',
        personal: '个人会员',
        visitor: '游客'
      }
      state.user.memTypeText = typeMap[payload.memType] || '';
      state.user.portraitUrl = payload.portraitUrl || tempUserImg;
    },
    SETUNREAD(state, payload) {
      state.unReadCount = payload;
    }
  },
  actions: {
    setActiveMenu ({ commit }, payload) {
      commit('SETACTIVEMENU', payload)
    },
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          commit('SETUSERINFO', res);
          resolve();
        }).catch(err => {
          localStorage.removeItem('token');
          reject(err);
        })
      })
    },
    onLogout({ commit }) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('token');
        commit('SETUSERINFO', null);
        resolve();
      })
    },
    getUnReadCount({ state, commit }) {
      return new Promise((resolve, reject) => {
        state.user && getAllUnReadTotal().then(count => {
          commit('SETUNREAD', count);
          resolve();
        }).catch(err => {
          reject(err);
        })
      })
    }
  },
  modules: {
  }
})
